import React, { useState } from "react";
import { FaArrowCircleRight, FaArrowCircleLeft } from "react-icons/fa";

export default function SliderData() {
  const imgData = [
    {
      image:
        "https://images.unsplash.com/photo-1529778873920-4da4926a72c2?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8YW5pbWFsc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    {
      image:
        "https://images.unsplash.com/photo-1591824438708-ce405f36ba3d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YW5pbWFsc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    {
      image:
        "https://images.unsplash.com/photo-1493916665398-143bdeabe500?ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8YW5pbWFsc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    {
      image:
        "https://images.unsplash.com/photo-1583499871880-de841d1ace2a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzh8fGFuaW1hbHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    {
      image:
        "https://images.unsplash.com/photo-1456926631375-92c8ce872def?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YW5pbWFsc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    {
      image:
        "https://images.unsplash.com/photo-1489084917528-a57e68a79a1e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjN8fGFuaW1hbHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
  ];

  const [current, setCurrent] = useState(0);
  const imgLength = imgData.length;

  const arrowRight = () => {
    setCurrent(current === imgLength - 1 ? 0 : current + 1);
  };

  const arrowLeft = () => {
    setCurrent(current === 0 ? imgLength - 1 : current - 1);
  };

  if (!Array.isArray(imgData) || imgLength <= 0) {
    return null;
  }

  return (
    <div className="slider">
      <FaArrowCircleLeft onClick={arrowLeft} className="arrow-left" />

      <FaArrowCircleRight onClick={arrowRight} className="arrow-right" />

      {imgData.map((img, index) => {
        return (
          <div
            className={index === current ? "slide active" : "slide"}
            key={index}
          >
            {index === current && (
              <img
                src={img.image}
                alt="animaux"
                style={{
                  width: 1000,
                  height: 600,
                  marginBottom: 50,
                  borderRadius: 10,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
